import React from "react";
import "./Footer.css";


function Footer() {
    return (
       <footer className="footer">
        <div className="main-content">
          <p className="footer-text">Copyright 2020 Argent Bank</p>
        </div>
    </footer>
    )
}

export default Footer;